import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { NProgressLoading as Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main'),
	loading: Spin,
});

const Detail = Loadable({
	loader: () => import('./routes/detail'),
	loading: Spin,
});
export default ({ match }) => {
	return (
		<Switch>
			<Route path={`${match.url}/detail/:id`} component={Detail} />
			<Route path={match.url} component={Main} />

		</Switch>
	);
};
